export enum ApiLimits {
    MaxRecipientsOnDisplayNewAppointment = 100,
    MaxSubjectLength = 255,
    MaxBodyLengthOnDisplayApis = 32 * 1024,
    MaxLocationLengthOnDisplayNewAppointment = 255,
    MaxAttachmentNumberOnDisplayApis = 100,
    MaxRecipientsPerCall = 100,
}

export default ApiLimits;
